import {DataTransferObjectValidation} from "../../../type/Types";
import {ShoppingMainKeywordValueObject} from "../../vo/content/ShoppingMainKeywordValueObject";

export namespace ShoppingMainKeywordDataTransferObject {
    export type Post = {
        shoppingId: bigint
        rank: number | null
        mainKeywordString: string | null
    }

    export namespace Post {
        export const description: Record<keyof ShoppingMainKeywordValueObject, string> = ShoppingMainKeywordValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            shoppingId(o: string): bigint | Error {
                try {
                    return BigInt(o)
                } catch (e) {
                    return new Error('shoppingId', { cause: e })
                }
            },
            rank(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('rank', { cause: e })
                }
            },
            mainKeywordString(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
        }

    }

    export type PostByExposedAt = {
        exposedAt: string
    }

    export namespace PostByExposedAt {
        export const description: Record<keyof ShoppingMainKeywordValueObject, string> = ShoppingMainKeywordValueObject.description

        export const validation: DataTransferObjectValidation<PostByExposedAt> = {
            exposedAt(o: string): string | Error {
                try {
                    return new Date(o).toISOString().substring(0, 10)
                } catch (e) {
                    return new Error('exposedAt', { cause: e })
                }
            },

        }
    }

    export type PatchMainKeyword = {
        mainKeyword: string
    }

    export namespace PatchMainKeyword {
        export const description: Record<keyof ShoppingMainKeywordValueObject, string> = ShoppingMainKeywordValueObject.description

        export const validation: DataTransferObjectValidation<PatchMainKeyword> = {
            mainKeyword(o: string): string  {
                return o
            },

        }
    }

    export type PatchRank = {
        ids: number[]
    }

    export namespace PatchRank {
        export const description: Record<keyof ShoppingMainKeywordValueObject, string> = ShoppingMainKeywordValueObject.description

        export const validation: DataTransferObjectValidation<PatchRank> = {
            ids(o: string): number[]  {
                return o.split(',').map(value => Number(value));
            },

        }
    }
}

